export enum TabEnum {
  EMPRESAS,
  AVISOS,
}
